export enum Breakpoints {
  Mobile = '375',
  Tablet = '768',
  TabletWide = '1080',
  Desktop = '1280',
  DesktopWide = '1440',
}

export const ContentMaxWidths = {
  Mobile: 375,
  Tablet: 768,
  TabletWide: 1080,
  Desktop: 1280,
  DesktopWide: 1280,
} as const

export enum VerticalAlignment {
  Top = 'top',
  Bottom = 'bottom',
  Default = 'default',
}

export enum SingleColBeforeBreakpoints {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum TwoColumnGapSize {
  None = 'None',
  M = 'M',
  L = 'L',
}

export enum TwoColumnRatio {
  OneToOne = '1:1',
  OneToTwo = '1:2',
  TwoToOne = '2:1',
  FiveToSeven = '5:7',
  SevenToFive = '7:5',
}
